import request from "@/request"

/**
 * 查询标签列表
 */
export function getAllTags() {
    return request({
        url: "/tags",
        method: "GET",
    })
}

/**
 * 最热标签
 */
export function getHotTags() {
    return request({
        url: "/tags/hot",
        method: 'GET'
    })
}

/**
 * 查询所有标签（包括每个标签对应的文章数量）
 */
export function listTagsDetail() {
    return request({
        url: "/tags/detail",
        method: 'GET',
    })
}

/**
 * 根据标签id查询标签详情
 */
export function getTagDetailById(id) {
    return request({
        url: `/tags/detail/${id}`,
        method: "GET",
    })
}
